import React, { useState, useEffect } from 'react';
import { translatePost } from '../utils/translation';

// Locale mapping for date formatting
const LOCALE_MAP = {
  ka: 'ka-GE',
  ru: 'ru-RU',
  en: 'en-US'
};

export default function Post({ post, language = 'ka' }) {
  const [translatedPost, setTranslatedPost] = useState(post);
  const [isTranslating, setIsTranslating] = useState(false);

  useEffect(() => {
    async function translate() {
      if (language === 'ka') {
        setTranslatedPost(post);
        return;
      }

      setIsTranslating(true);
      try {
        const translated = await translatePost(post, language);
        setTranslatedPost(translated);
      } catch (error) {
        console.error('Translation failed:', error);
        setTranslatedPost(post);
      } finally {
        setIsTranslating(false);
      }
    }

    translate();
  }, [post, language]);

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const locale = LOCALE_MAP[language] || 'en-US';
    return date.toLocaleDateString(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition duration-300">
      {translatedPost.image && (
        <img 
          src={translatedPost.image} 
          alt={translatedPost.title}
          className="w-full h-64 object-cover"
        />
      )}
      <div className="p-6">
        <h3 className="text-2xl font-bold text-slate-800 mb-2">
          {translatedPost.title}
          {isTranslating && <span className="text-xs text-orange-500 ml-2">⟳</span>}
        </h3>
        <p className="text-sm text-slate-500 mb-4">{formatDate(translatedPost.timestamp)}</p>
        <p className="text-slate-600 whitespace-pre-wrap">{translatedPost.content}</p>
      </div>
    </div>
  );
}
